import makeStyles from '@mui/styles/makeStyles'
import { appBarHeight as defaultAppBarHeight } from '../app-toolbar-consumer/style'
import { paidConsumerMobileNavHeight, paidConsumerDesktopNavHeight } from '../app-toolbar-paid-consumer/style'
import { trialBannerHeight } from '../app-toolbar-paid-consumer/navigation/style'

const bottomGap = 8

export const useStyles = makeStyles(({ breakpoints, palette }) => ({
  root: {
    '& .MuiBackdrop-root': {
      borderTop: ({ isPaidConsumer }) => `${isPaidConsumer ? `1px solid ${palette.primary.main}` : 'none'}`,
      background: ({ isPaidConsumer, isTrialBannerVisible }) => {
        const navHeight = isPaidConsumer ? paidConsumerDesktopNavHeight : defaultAppBarHeight
        const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
        return `linear-gradient(transparent, transparent ${totalHeight}px, white ${totalHeight}px)`
      }
    },
    '& .MuiDialog-paper': {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: ({ isPaidConsumer, isTrialBannerVisible }) => {
        const navHeight = isPaidConsumer ? paidConsumerDesktopNavHeight : defaultAppBarHeight
        const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
        return `${totalHeight}px`
      },
      margin: 0,
      maxWidth: 'inherit',
      [breakpoints.up('md')]: {
        height: ({ isPaidConsumer, isTrialBannerVisible }) => {
          const navHeight = isPaidConsumer ? paidConsumerDesktopNavHeight : defaultAppBarHeight
          const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
          return `calc(100% - (${totalHeight} + ${bottomGap}px))`
        },
        width: ({ isPaidConsumer }) => `${isPaidConsumer ? '100%' : 'calc(100% - 64px)'}`
      },
      [breakpoints.down('lg')]: {
        top: ({ isPaidConsumer, isTrialBannerVisible }) => {
          const navHeight = isPaidConsumer ? paidConsumerMobileNavHeight : defaultAppBarHeight
          const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
          return `${totalHeight}px`
        }
      },
      borderRadius: 0,
      boxShadow: `0px 1px 2px 0px #1818180F,
                  0px 1px 3px 0px #1818181A`
    }
  }
}))
